import React, { Component } from 'react'

import { get, put } from '../../api'
import { emit } from '../../events'

import Form from '../Form/Form'

import './BlocksWords.css'

class BlocksWords extends Component {

	state = {}

	componentDidMount() {
		this.fetchBlockWords()
	}

	fetchBlockWords = async () => {
		try {
			const blockWords = await get('/blockwords')
			this.setState({
				blockWords: blockWords.join('\n')
			})
		} catch (err) {
			alert(err.message)
		}
	}

	onSubmit = async () => {
    	const { blockWords = '' } = this.state
    	try {
    		await put('/blockwords', {
    			blockWords: JSON.stringify(blockWords.split('\n'))
    		})
    		emit('snackbar', 'Block words saved!')    		
    	} catch (err) {
    		alert(err.message)
    	}
	}

    render() {
    	const { blockWords = '' } = this.state

        return (
            <div className="BlockWords">
            	<Form onSubmit={this.onSubmit}>
	            	<textarea
	            		spellCheck="false"
	            		value={blockWords}
	            		onChange={e => this.setState({ blockWords: e.target.value })}>
	            	</textarea>
	            	<div>
	            		<button>Save</button>
	            	</div>
	            </Form>
            </div>
        )
    }
}

export default BlocksWords



// WEBPACK FOOTER //
// ./src/components/BlockWords/BlockWords.js